import React, { Component} from 'react';
 


class vcEnd extends Component {
  
  constructor(props) {
    super(props);
    this.handleLoop = this.handleLoop.bind(this);
    this.state = {
      usr: props.data.usr,      
      logo: props.data.logo,
      gamestate: props.data.gamestate,
      handleStateChange: props.data.handleStateChange,
      startcnt: 0
    }
    this.looppointer = {};    
  }
  
componentDidMount(){
  this.looppointer = setInterval(this.handleLoop,1);
}  

handleLoop(){
  let cnt = this.state.startcnt;
  cnt ++
  if (cnt>10000){cnt=0}
  this.setState({startcnt: cnt})
  
}
closeMe(){
  clearInterval(this.looppointer);
  this.state.handleStateChange('start');
}
handleClick(event){
  this.closeMe();  
}  
   
    render() {
    
      return (
      <div onClick={(e)=>this.handleClick(e)}>
        <h2>VOIDCHEESE END SCENE</h2>
        <div>{this.state.startcnt}</div>  
      </div>
              
           );            
              
  
      
    }  

  
}




export default vcEnd; 


// WEBPACK FOOTER //
// ./src/components/Games/VoidCheddar/Pages/end.js